import React, { useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  dummyimage,
  Search_icon,
  toggle_off,
  toggle_on,
} from "../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import { toast } from "react-toastify";
import DocDragAndDrop from "../../components/Property/DocDragAndDrop";
import { set } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { receptionList } from "../redux/api/dummyJson";
// import Select from "react-select";
import Select, { components } from "react-select";

const EditDocumentVerification = () => {
  const [addPopup, setAddPopup] = useState(false);
  const [gstName, setGstName] = useState();
  const [errors, setErrors] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState([]);
  const [draggableImages, setDraggableImages] = useState([]);
  const imgRef = useRef(null);
  const [policy, setPolicy] = useState("");
  const [receptionist, setReceptionist] = useState("");
  const [text, setText] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const [selectReception, setSelectReception] = useState();
  const [popUpData, setPopupData] = useState({
    name: "",
    image: "",
  });

  const location = useLocation();
  const navigate = useNavigate();
  const type = location?.state?.type;
  console.log("type", type);
  const [selectedReceptionists, setSelectedReceptionists] = useState([]);
  const [selectedReceptionist, setSelectedReceptionist] = useState(null);

  const handleChange = (selected) => {
    setSelectedReceptionists(selected || []);
  };

  const receptionistOptions = [
    { value: "2293", label: "Pram Kumar R", id: 2293 },
    { value: "1293", label: "Ram Kumar", id: 1293 },
    { value: "1294", label: "Kumar", id: 1294 },
  ];
  // Custom Option with Radio Button
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="d-flex ac-jb">
          <label>{props.label}</label>
          <span
            style={{
              height: "16px",
              width: "16px",
              borderRadius: "50%",
              border: "2px solid #7B61FF",
              display: "inline-block",
              position: "relative",
            }}
          >
            {props.isSelected && (
              <span
                style={{
                  height: "8px",
                  width: "8px",
                  backgroundColor: "#7B61FF",
                  borderRadius: "50%",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            )}
          </span>
        </div>
      </components.Option>
    );
  };
  const handleRemove = (value) => {
    setSelectedReceptionists((prev) =>
      prev.filter((item) => item.value !== value)
    );
  };

  const CustomMultiValue = () => null;

  // const handleImageChange = (event) => {
  //     const file = event.target.files[0];
  //     setSelectedImage(event.target.files[0]);
  // };
  const handleImageClick = () => {
    inputRef.current.click();
  };

  // const handleImageChange = (e) => {
  //     const files = Array.from(e.target.files);
  //     if (files.length > 0) {
  //         // Store previous files + new file
  //         setSelectedImage((prev) => [...prev, ...files]);
  //     }
  // };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage([file]);
    }
  };

  const editDocHandler = (index, file) => {
    // setType("edit");
    setAddPopup(true);
    setGstName("GST Document");
    setPopupData({
      name: file?.name,
      image: file?.image,
    });
  };

  const handleAddText = () => {
    setText((prev) => [...prev, policy]); // append new policy to array
    // setPolicy(""); // optional: clear textarea after adding
  };
  const handleTextDelete = (index) => {
    setText((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    if (!popUpData?.name) {
      toast.error("Enter Document Name");
      return;
    }
    if (!popUpData?.image) {
      toast.error("Upload Document");
      return;
    } else {
      let temp = [...selectedImage];
      temp.push(popUpData);
      setSelectedImage(temp);
      setPopupData({
        name: "",
        image: "",
      });
      onReset();
      setErrors(false);
      setAddPopup(false);
    }
  };

  const onReset = () => {
    setPopupData({
      name: "",
      image: "",
    });
  };

  const addDocHandler = () => {
    setGstName(""); // Reset GST Name
    // setSelectedImage([]);     // Reset selected file
    setAddPopup(true); // Open popup
  };

  console.log("popUpData", popUpData, "selectedImage", selectedImage);

  return (
    <div>
      <Topbar header={"Properties"} subHead={"Verification"} />
      <div>
        {/* {type == "edit" && ( */}
        <div className="d-flex ac-jb">
          <div className="d-flex ac-jb ">
            <p
              onClick={() => {
                navigate("/propertie-req-edit", {
                  state: { type: "edit", submit: "submit" },
                });
              }}
              className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-act-tab pointer"
            >
              Property Request
            </p>
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line"></p>
            <p className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-on-tab">
              Document Verification
            </p>
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line"></p>
            <p className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-tab">
              MMC
            </p>
          </div>
        </div>
        {/* )} */}
        <p
          onClick={() => {
            addDocHandler();
          }}
          className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 green my-4 pointer"
        >
          +Add Document
        </p>
        {selectedImage?.length != 0 && (
          <div
            className="d-flex flex-wrap gap-5 pb-5"
            style={{ borderBottom: "2px solid #D9D9D9" }}
          >
            {selectedImage?.map((file, index) => (
              <div key={index} className="col-md-5">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  {file?.name}
                </p>
                <p
                  onClick={() => editDocHandler(index, file)}
                  className="doc-input pointer"
                >
                  {file?.image?.name}
                </p>
              </div>
            ))}
          </div>
        )}

        <div
          style={{
            borderBottom: "2px solid #D9D9D9",
            paddingBottom: "20px",
            marginTop: "20px",
          }}
        >
          <DocDragAndDrop
            draggableImages={draggableImages}
            setDraggableImages={setDraggableImages}
          />
        </div>
        <p
          onClick={() => {
            handleAddText();
          }}
          className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer"
        >
          <span className="green">+Add Text </span>(Optional)
        </p>
        <div className="">
          {text.map((item, ind) => {
            return (
              <div className="w-100 mt-5">
                <div className="d-flex ac-jb">
                  <input
                    className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 gray input-border w-30 "
                    placeholder="Text"
                  />
                  <CloseSharpIcon
                    onClick={() => handleTextDelete(ind)}
                    className="pointer gray"
                  />
                </div>
                <div className="d-flex ae-jb input-border p-1">
                  {/* <textarea style={{ maxHeight: "80px" }}
                                    // maxLength={250}
                                    value={policy}
                                    onChange={(e) => setPolicy(e.target.value)}
                                    placeholder='Write Here....'
                                    // onKeyPress={handleKeyPress}
                                    className='border-0 mb-3 w-80'
                                /> */}
                  <textarea
                    style={{ maxHeight: "100px" }}
                    value={item}
                    onChange={(e) => {
                      const newText = [...text];
                      newText[ind] = e.target.value;
                      setText(newText);
                    }}
                    placeholder="Write Here...."
                    className="border-0 mb-3 w-100"
                  />
                  {/* <button className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1" style={{ minWidth: "100px" }}  >
                                        Edit
                                    </button> */}
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex ac-js gap-3 mt-5">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Receptionist
          </p>
          <button
            //  disabled={type == "edit" ? false : true}
            className="cust-btn"
          >
            <img
              onClick={() => setReceptionist(!receptionist)}
              src={receptionist ? toggle_on : toggle_off}
              className="roles-icon pointer"
              alt=""
            />
          </button>
        </div>
        {receptionist && (
          <div
            // className={`toggle-drop mb-5  col-md-4 ${receptionist ? 'open' : 'closed'}`}
            className={" mb-5  col-md-4 "}
          >
            <p className=" f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 sec mt-4">
              Add Receptionist
            </p>

            <div>
              <Select
                options={receptionistOptions}
                value={selectedReceptionists}
                onChange={handleChange}
                placeholder="Select Receptionist"
                isMulti
                isSearchable
                isClearable={false}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option: CustomOption,
                  MultiValue: CustomMultiValue, // hides inside select
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#ccc",
                    minHeight: "40px",
                  }),
                }}
              />

              {/* Selected items OUTSIDE the select box */}
              {selectedReceptionists.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  {selectedReceptionists.map((person) => (
                    <div
                      key={person.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "6px",
                        padding: "6px 10px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    >
                      <span>{person.label}</span>
                      <div className="">
                        <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
                          ID: {person.id}
                        </span>
                        <button
                          onClick={() => handleRemove(person.value)}
                          style={{
                            marginLeft: "auto",
                            height: "16px",
                            width: "16px",
                            borderRadius: "50%",
                            border: "2px solid #7B61FF",
                            display: "inline-block",
                            position: "relative",
                          }}
                        >
                          <span
                            style={{
                              height: "8px",
                              width: "8px",
                              backgroundColor: "#7B61FF",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {addPopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <div className="d-flex ac-je">
                {/* <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                                    {type == "add" ? "Add" : "Edit"}
                                </p> */}
                <CloseSharpIcon
                  onClick={() => {
                    setAddPopup(false);
                    onReset();
                    setErrors("");
                  }}
                  className="pointer"
                />
              </div>
              {/* <div className='d-flex ac-js mt-4'> */}
              <div className="">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                  Name
                </p>
                <input
                  className="doc-input"
                  name="email"
                  value={popUpData?.name}
                  onChange={(e) =>
                    setPopupData((pre) => ({ ...pre, name: e.target.value }))
                  }
                  type="text"
                  placeholder="GST Document"
                />
              </div>
              <div className="d-flex ae-jb px-2 mt-4">
                <div className="w-60">
                  <div className=" w-100 d-flex ac-jb">
                    <div className="position-relative w-100">
                      {/* <HighlightOffRoundedIcon className='img-cancel' /> */}
                      <div className=" w-100">
                        <div>
                          {console.log("sssss", selectedImage)}

                          <div className="d-flex ae-js gap-1">
                            {/* {selectedImage.length > 0 ? (selectedImage.map((file, index) => (
                                                            <div key={index} className='d-flex ae-js gap-1'>
                                                                <p>{file.name}</p>
                                                                {/* {type == "edit" && (<button className="view-btn">View</button>)} *
                                                            </div>
                                                        ))) : (
                                                            <p className='bg-gray1 white rounded d-flex ac-jc' style={{ height: "50px", width: "60%" }}>No file chosen</p>
                                                        )} */}
                            <p
                              className="bg-gray1 white rounded d-flex ac-jc"
                              style={{ height: "50px", width: "60%" }}
                            >
                              {popUpData?.image?.name
                                ? popUpData?.image?.name
                                : "No file chosen"}
                            </p>

                            {popUpData?.image && (
                              <button
                                className="view-btn d-flex gap-2 mt-1 "
                                // onClick={() => imgRef.current?.click()}
                              >
                                View
                              </button>
                            )}
                          </div>
                          <input
                            style={{
                              position: "absolute",
                              width: "100px",
                              height: "100px",
                              left: "0px",
                              top: "0px",
                            }}
                            type="file"
                            hidden
                            name="myImage"
                            accept="application/pdf"
                            ref={inputRef}
                            // onChange={handleImageChange}
                            onChange={(e) =>
                              setPopupData((pre) => ({
                                ...pre,
                                image: e.target.files[0],
                              }))
                            }
                          />
                          <button
                            className="submit-btn d-flex gap-2 mt-1 "
                            // onClick={() => imgRef.current?.click()}
                            onClick={handleImageClick}
                          >
                            <CloudUploadRoundedIcon /> Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
                {/* {selectedImage != "edit" && (
                                <h4 className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ms-2">
                                    Max Upload Size : 5MB   and  Banner Size 1200px 700px*
                                </h4>
                            )} */}
                <button
                  onClick={() => {
                    handleSubmit();
                    // logout();
                  }}
                  className="submit-btn f2 w-40"
                >
                  {/* {loading ? "Loading..." : "Confirm"}  {type == "edit" ? "Submit" : "Add"} */}
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="d-flex ac-je mt-5">
        {/* {type == "edit" && ( */}
        <button
          onClick={() => navigate("/propertie-mmc-edit")}
          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
        >
          Submit
        </button>
        {/* )} */}
      </div>
    </div>
  );
};
export default EditDocumentVerification;
